document.addEventListener('DOMContentLoaded', () => {
  let featuredCollection = document.querySelectorAll('.featured-collection-inner.swiper');
  featuredCollection.forEach(current => {
    let swiperOptions = JSON.parse(current.dataset.sliderOptions);
    
    // Check if Swiper is available
    function initializeSwiper() {
      if (typeof Swiper !== 'undefined') {
        let swiper = new Swiper(current, swiperOptions);
      } else {
        // Wait for Swiper to load
        setTimeout(initializeSwiper, 100); 
      }
    }
    
    initializeSwiper();
  });
});
  